export const MUTATION = {
  SET_SELECTED_TAG: 'setSelectedTag',
  SET_EXPANDED_DEAL: 'setExpandedDeal',
  SET_STATUS_GROUP: 'setStatusGroup',
  UPDATE_STATUS_GROUP_DEAL: 'updateStatusGroupDeal',
  SET_DASHBOARD: 'setDashboard',
  SET_LOADING: 'setLoading',
  SET_EXPANDED_DEAL_LOADING: 'setExpandedDealLoading',
  SET_ERROR: 'setError',
  TOGGLE_CREATE_NOTE_MODAL_VISIBILITY: 'toggleCreateNoteModalVisibility',
  SET_NOTIFICATION: 'setNotification',
  UNSET_NOTIFICATION: 'unsetNotification',
};

export const ACTION = {
  FETCH_DASHBOARD: 'fetchDashboard',
  FETCH_EXPANDED_DEAL: 'fetchExpandedDeal',
};

export const GETTER = {
  TAGS: 'tags',
  COLUMNS: 'columns',
  DASHBOARD: 'dashboard',
  SELECTED_TAG: 'selectedTag',
  EXPANDED_DEAL: 'expandedDeal',
  IS_LOADING: 'isLoading',
  IS_EXPANDED_DEAL_LOADING: 'isExpandedDealLoading',
  HAS_ERROR: 'hasError',
  ERROR: 'error',
  CREATE_NOTE_MODAL_OPTIONS: 'createNoteModalOptions',
};
